import { styled } from '@mui/material/styles';

export const ScrollableBodyStyled = styled('div')`
  position: relative;
  display: flex;
  flex-direction: column;
  height: inherit;
  padding-bottom: 80px;
  overflow-y: auto;

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    justify-content: flex-start;
  }
`;
